var projectSliders = document.querySelectorAll('.project-swiper');

var initProjectSlider = (item) => {
  let options = {
    navigation: {
      nextEl: item.parentElement.parentElement.parentElement.querySelector('.project-swiper-nav__next'),
      prevEl: item.parentElement.parentElement.parentElement.querySelector('.project-swiper-nav__prev'),
    },
    loop: false,
    iOSEdgeSwipeDetection: true,
    iOSEdgeSwipeThreshold: 0,
    simulateTouch: true,
    preventInteractionOnTransition: true,
    speed: 500,
    height: 'auto',
    initialSlide: 0,
    spaceBetween: 30,
    slidesPerView: 'auto',
  };
  var projectSlider = new Swiper(item, options);
};

projectSliders.forEach((item, i) => {
  let slider = false;
  function initSwiper() {
    var screenWidth = window.innerWidth;
    if (screenWidth <= 992 && slider) {
      slider.destroy(true, true);
      slider = false;
    } else if (screenWidth > 992 && !slider) {
      slider = initProjectSlider(item);
    }
  }

  initSwiper();
  window.addEventListener('resize', initSwiper);
});
